import classes from "./styles.module.scss";
import { Component } from "react";
import React from "react";
import { observer } from "mobx-react";
import Layouter from "../../containers/Layouter";
import Header from "../Header";
import Footer from "../Footer";
import { MainStore } from "../../stores/MainStore";
import Label from "../Label";
import arrowLeft from "../../assets/images/left-arrow.svg";
import Image from "../Image";
interface NotFoundProps {
  store: MainStore;
}
@observer
class NotFound extends Component<NotFoundProps> {
  render() {
    const { store } = this.props;
    return (
      <div className={classes.NotFound}>
        <Layouter>
          <Header store={store} />
          <div className={classes.NotFoundBody}>
            <Label extraBig bold text={"404"} />
            <Label big id={"generic.notfound-header"} />
            <div className={classes.BackHome} onClick={e => store.backHome()}>
              <Image fitHeight src={arrowLeft} alt={"Arrow left nav"} />
              <Label bold small uppercase id={"generic.back.home"} />
            </div>
          </div>
          <Footer />
        </Layouter>
      </div>
    );
  }
}
export default NotFound;
